export const list = {
    instructional_picture: "url_instructional",
    data_sensors: "url_sensors"
}

export const listImage = [
    "instructional_picture",
    "data_sensors"
]